import request from '@/utils/http';
import { PFX } from '../constant/constant.js';
// 模板列表+查询
export const templateList = (params) => {
    return request({
        url: `${PFX}/bid/bidQuoteTmptHeaders`,
        method: 'post',
        data: params
    });
};
// 模板列表启用停用修改和头部修改
export const templateModify = (id, params) => {
    return request({
        url: `${PFX}/bid/bidQuoteTmptHeader/${id}`,
        method: 'put',
        data: params
    });
};
// 模板列表删除
export const templateDelete = (id) => {
    return request({
        url: `${PFX}/bid/bidQuoteTmptHeader/${id}`,
        method: 'delete'
    });
};
// 模板详情
export const templateDetail = (params) => {
    return request({
        url: `${PFX}/bid/quoteTmptDefsManagerPage`,
        method: 'post',
        data: params
    });
};
// 模板详情头部新增
export const temptHeader = (params) => {
    return request({
        url: `${PFX}/bid/bidQuoteTmptHeader`,
        method: 'post',
        data: params
    });
};
// 模板详情底部删除
export const temptFooterDel = (params) => {
    return request({
        url: `${PFX}/bid/deleteBatch`,
        method: 'post',
        data: params
    });
};
// 模板详情底部列表更改新增
export const temptFooterChange = (params) => {
    return request({
        url: `${PFX}/bid/insertBatch`,
        method: 'post',
        data: params
    });
};
// 启用-招标模板审批
export const approvalTemplate = (params) => {
    return request({
        url: `${PFX}/bid/templateIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 试点-模板详情头部-查询
export const queryBidMoreRuleTplHeader = data => {
    return request({
        url: `${PFX}/bid/queryBidMoreRuleTplHeader`,
        method: 'post',
        data
    });
};
// 试点-模板详情头部新增-保存
export const saveBidMoreRuleTplHeader = data => {
    return request({
        url: `${PFX}/bid/saveBidMoreRuleTplHeader`,
        method: 'post',
        data
    });
};
// 试点-模板详情头部编辑-保存
export const editBidMoreRuleTplHeader = data => {
    return request({
        url: `${PFX}/bid/editBidMoreRuleTplHeader`,
        method: 'post',
        data
    });
};
// 试点-模板详情字段数据-查询
export const queryBidMoreRuleTplField = data => {
    return request({
        url: `${PFX}/bid/queryBidMoreRuleTplField`,
        method: 'post',
        data
    });
};
// 试点-模板详情字段数据-保存
export const saveBidMoreRuleTplField = data => {
    return request({
        url: `${PFX}/bid/saveBidMoreRuleTplField`,
        method: 'post',
        data
    });
};
// 试点-模板详情字段数据-删除
export const delBatchBidMoreRuleTplField = data => {
    return request({
        url: `${PFX}/bid/delBatchBidMoreRuleTplField`,
        method: 'post',
        data
    });
};
// 试点-查询模板的计费规则
export const calcTempByCodes = data => {
    return request({
        url: `${PFX}/bid/calcTemplatePriceTypeListByCodes`,
        method: 'get',
        params: data
    });
};
